import WalletOptionsDialog from '@/components/web3/WalletOptionsDialog'
import BPTDialog from './BPTDialog/BPTDialog'
import { useModalOpenState } from '@/providers/ModalOpenStateProvider'
import MissedDrawDialog from './MissedDrawDialog'
import { useMissedDraw } from '@/providers/MissedDrawProvider'

export type ModalsProps = {}

export default function Modals(props: ModalsProps) {
    const { bptDialogOpen, walletOptionsDialogOpen } = useModalOpenState()
    const { missedRoundIndex } = useMissedDraw()

    return <>
        <BPTDialog open={bptDialogOpen.value} onClose={() => bptDialogOpen.update(false)} />
        <WalletOptionsDialog open={walletOptionsDialogOpen.value} onClose={() => walletOptionsDialogOpen.update(false)} />
        {missedRoundIndex !== null && <MissedDrawDialog roundIndex={missedRoundIndex} />}
    </>
}